export default __webpack_public_path__ + "static/media/app.59dd9259.svg";